/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { MenuItem } from '@mui/material';

const menuItems = (options: Array<any>, abbrvUsed: boolean, addBlank: boolean = false) => {
  const finalOpts = addBlank
    ? [
        <MenuItem key='null' value=''>
          None
        </MenuItem>,
      ]
    : [];

  finalOpts.push(
    ...options.map((item, key) => (
      <MenuItem key={key} value={item.code}>
        {(abbrvUsed ? item.abbreviation : item.code) + ' - ' + item.description}
      </MenuItem>
    )),
  );

  return finalOpts;
};

export default menuItems;
